import { EditorialTextProps } from ".";

export default {
  title: "Editorial Text",
  type: "rh/components/content/editorial-text",
  isContainer: false,
  config: {
    emptyLabel: "Add editorial text content",
    isEmpty: (props: EditorialTextProps) => !props.fontStyle
  }
};
